// libs
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// utils
import { isEmpty } from '@/helpers/utils';
// styles
import styles from './Tab.module.scss';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
const Tab = (props) => {
    const { Icon, label, redirectUrl } = props;
    const location = useLocation();
    const navigator = useNavigate();
    const isActive = location.pathname === redirectUrl;
    const handleClick = () => {
        !isEmpty(redirectUrl) && navigator(redirectUrl, { replace: true });
    };
    return (React.createElement("div", { className: cx(styles.container, { [styles.active]: isActive }), onClick: handleClick },
        React.createElement(Icon, { fillColor: "black" }),
        React.createElement(Text, { variant: DlsFontVariants.button_Text_BT4, color: DlsColorTokens.text_Highest_Emphasis, className: styles.label }, label)));
};
export default Tab;
